import type {FC} from 'react';

interface RecoveryLeafIconProps {
  color: string;
  height?: number;
}

// Pathfinder leaf glyph exported from the recovery counter design
// (Figma: Member Detail pages, node 2699:113446), fill made tintable
export const RecoveryLeafIcon: FC<RecoveryLeafIconProps> = ({
  color,
  height = 16,
}) => (
  <svg
    width={(height * 13) / 16.4}
    height={height}
    viewBox="0 0 12.999 16.3984"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.6738 0L11.8086 0.00683594C11.8412 0.0101593 11.8734 0.0158165 11.9053 0.0214844C11.9471 0.0289171 11.988 0.0385132 12.0283 0.0498047C12.5828 0.204787 12.9904 0.713257 12.9912 1.31836L12.999 6.51367C12.999 10.1046 10.0826 13.0264 6.49902 13.0264H3.37109C2.97467 13.0264 2.64388 12.8641 2.41211 12.6035C2.29594 12.4692 2.20766 12.333 2.14062 12.2061C1.96447 11.8716 1.93556 11.5965 1.93457 11.5869C1.93459 11.8086 1.96919 12.1099 2.03418 12.3105C2.13695 12.6289 2.31228 12.9143 2.54297 13.1455C2.77264 13.3757 3.05738 13.5513 3.37305 13.6543V16.3984C1.36275 15.2908 0.000106436 13.1495 0 10.6885V6.5127C0.000128117 2.9167 2.9094 0.00013411 6.49902 0H11.6738ZM6.49902 3.3877C6.41221 3.3877 6.32624 3.39142 6.24121 3.39844C6.05239 3.41394 5.86833 3.44631 5.69043 3.49414C5.53521 3.53597 5.38495 3.59001 5.24023 3.6543C5.11345 3.71052 4.99229 3.77665 4.875 3.84863C4.77422 3.91056 4.67684 3.97718 4.58398 4.0498C4.50092 4.11474 4.42078 4.183 4.34473 4.25586C4.31033 4.28885 4.27701 4.32291 4.24414 4.35742C4.00085 4.61264 3.80087 4.90852 3.6543 5.23438C3.47841 5.62506 3.37895 6.05776 3.37891 6.51367V8.9248H3.37793V8.94531C4.01036 7.76619 5.27176 5.89993 6.94336 5.13281C5.1542 7.05913 4.61219 8.15464 4.57129 9.64062H6.49902C8.21895 9.64062 9.61914 8.23819 9.61914 6.51367H9.61816V3.3877H6.49902Z"
      fill={color}
    />
  </svg>
);
